export type EnumAliasMap<T extends string | number> = Record<string, T>;

function normalizeEnumToken(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
}

export function mapToEnumValue<T extends string | number>(
  inputValue: unknown,
  enumValues: readonly T[],
  fallbackValue: T,
  aliases: EnumAliasMap<T> = {},
): T {
  if (inputValue == null) {
    return fallbackValue;
  }

  if (enumValues.includes(inputValue as T)) {
    return inputValue as T;
  }

  if (typeof inputValue !== 'string') {
    return fallbackValue;
  }

  const trimmedInput = inputValue.trim();
  if (!trimmedInput) {
    return fallbackValue;
  }

  const normalizedInput = normalizeEnumToken(trimmedInput);

  for (const [alias, mappedValue] of Object.entries(aliases)) {
    if (normalizeEnumToken(alias) === normalizedInput) {
      return enumValues.includes(mappedValue) ? mappedValue : fallbackValue;
    }
  }

  for (const enumValue of enumValues) {
    if (normalizeEnumToken(String(enumValue)) === normalizedInput) {
      return enumValue;
    }
  }

  return fallbackValue;
}
